import React, { useEffect, useState } from "react";
import { FaChevronLeft, FaChevronRight, FaRegCalendar } from "react-icons/fa";
import { useFetchMyOverduesQuery } from "../../slice/logdetailSlice";
import Loader from "../common/Loader";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export const OverdueComponent = ({ overdueTasks }) => {
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  // const { role: login_user_role } = login_user;
  const { role: login_user_role } = login_user || {};

  const {
    data: my_overdue,
    isLoading: my_overdue_loading,
    refetch: myoverdue_refetch,
  } = useFetchMyOverduesQuery();

  // RTK Query automatically fetches on mount; redundant refetch on mount removed

  const navigate = useNavigate();

  const ITEMS_PER_PAGE = 5;
  const [page, setPage] = useState(1);

  const totalTasks = my_overdue?.length || 0;
  const totalPages = Math.ceil(totalTasks / ITEMS_PER_PAGE);

  const paginatedTasks = my_overdue?.slice(
    (page - 1) * ITEMS_PER_PAGE,
    page * ITEMS_PER_PAGE
  );

  const handlePageChange = (direction) => {
    if (direction === "prev" && page > 1) setPage(page - 1);
    if (direction === "next" && page < totalPages) setPage(page + 1);
  };

  return (
    <>
      {my_overdue_loading ? (
        <Loader />
      ) : (
        <div className="tableScroll bg-white p-4 rounded-3">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <div className="d-flex align-items-center">
              <h5 className="cardsub_title mb-0 pe-3">
                {login_user_role === "ADMIN" || login_user_role === "CLIENT"
                  ? "All Overdues"
                  : "My Overdues"}
              </h5>
              <div className="cardsub_title_line"></div>
            </div>
            <span className="ms-3 text-rgba-gray small">
              Total: {totalTasks}
            </span>
          </div>

          {paginatedTasks?.map((task, index) => (
            <div key={index} className="card bg-white border-0">
              <div
                className="card-body p-0"
                onClick={() =>
                  navigate(
                    `/projects/projectDetail/${task.project_id}/taskdetail/${task.task_id}`
                  )
                }
                style={{ cursor: "pointer" }}
              >
                <h6 className="card-title fw-bold">{task.title}</h6>
                <div className="d-flex justify-content-between">
                  <div className="d-flex card-text align-items-center text-rgba-gray mb-2">
                    <span className="text-rgba-gray">{task.project_name}</span>
                  </div>
                  <div className="d-flex align-items-center">
                    <FaRegCalendar className="text-rgba-gray me-2" />
                    <small className="text-rgbr-red">
                      Late by {task.late_by_days} days
                    </small>
                  </div>
                </div>
              </div>
              <hr />
            </div>
          ))}

          {/* Pagination Controls */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-end align-items-center mt-3">
              <FaChevronLeft
                onClick={page === 1 ? null : () => handlePageChange("prev")}
                className={`mx-2 ${
                  page === 1
                    ? "text-muted pointer-events-none"
                    : "cursor-pointer"
                }`}
                style={{
                  opacity: page === 1 ? 0.3 : 1,
                  cursor: page === 1 ? "not-allowed" : "pointer",
                }}
              />
              <span className="mx-2">{`Page ${page} of ${totalPages}`}</span>
              <FaChevronRight
                onClick={
                  page === totalPages ? null : () => handlePageChange("next")
                }
                className={`mx-2 ${
                  page === totalPages
                    ? "text-muted pointer-events-none"
                    : "cursor-pointer"
                }`}
                style={{
                  opacity: page === totalPages ? 0.3 : 1,
                  cursor: page === totalPages ? "not-allowed" : "pointer",
                }}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};
